const { connect } = require('react-redux');
const BrokerCustomWalletConfiguration =  require ('./brokerCustomWalletConfiguration');

// @ actions
const portfolios = require('../../actions/brokerCustomWalletPortfolios.js');
const BrokerMyInvestmentsActions = require('actions/brokerMyInvestments');
const editablePortfolio = require('../../actions/brokerCustomWalletEditablePortfolio.js');
const myWalletActions = require('actions/myWallet.js');

module.exports.BrokerCustomWalletConfiguration = connect(
    state => ({
        immBrokerMyInvestments: state.brokerMyInvestments,
        immBrokerCustomWalletPortfolios: state.brokerCustomWalletPortfolios,
        immBrokerCustomWalletInterveners: state.brokerCustomWalletInterveners
    }),
    {
        getPortfolioList: portfolios.getPortfolioList,
        getDetailsByPortfolio: portfolios.getDetailsByPortfolio,
        removeWallet: portfolios.removeWallet,
        setPortfolioToDelete: portfolios.setPortfolioToDelete,
        setPortfolioOnViewMode: portfolios.setPortfolioOnViewMode,
        setPortfolioOnEditionMode: portfolios.setPortfolioOnEditionMode,
        cancelEdition: portfolios.cancelEdition,
        cancelDelete: portfolios.cancelDelete,
        getDefaultViewID: myWalletActions.getDefaultViewID,
        cancelChangeDefault: portfolios.cancelChangeDefault,
        confirmedChangeDefault: portfolios.confirmedChangeDefault,
        changeDefault: portfolios.changeDefault,
        changeDefaultConfirmed: portfolios.changeDefaultConfirmed,
        updatePortfolio: portfolios.updatePortfolio,
        fetchMyInvestments: BrokerMyInvestmentsActions.fetchMyInvestments,
        changeDefaultCheckboxChanged: portfolios.changeDefaultCheckboxChanged,
        acceptLeaveEditionToDelete: portfolios.acceptLeaveEditionToDelete,
        acceptLeaveEditionToEdition: portfolios.acceptLeaveEditionToEdition,
        cancelLeaveEdition: portfolios.cancelLeaveEdition,
        setOnEditMode: portfolios.setPortfolioOnEditionMode,
        loadEditablePortfolioById: editablePortfolio.loadEditablePortfolioById,
        getContractsList: editablePortfolio.getContractsList,
        outdateMyInvestments: BrokerMyInvestmentsActions.outdateMyInvestments,
    }
)(BrokerCustomWalletConfiguration);
